/* tslint:disable */
/* eslint-disable */
/**
 * Payment App-Tier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Classification = {
    Normal: 'NORMAL',
    Group: 'GROUP',
    Gco: 'GCO',
    Sop: 'SOP',
    Proxy: 'PROXY',
    Registration: 'REGISTRATION',
    Renewal: 'RENEWAL',
    Upgrade: 'UPGRADE',
    Downgrade: 'DOWNGRADE',
    Digital: 'DIGITAL',
    Wht: 'WHT',
    Replacement: 'REPLACEMENT',
    Amc: 'AMC',
    Service: 'SERVICE',
    CustomerService: 'CUSTOMER_SERVICE',
    AutoRenewalImpersonation: 'AUTO_RENEWAL_IMPERSONATION',
    RandomStaff: 'RANDOM_STAFF'
} as const;
export type Classification = typeof Classification[keyof typeof Classification];


export function ClassificationFromJSON(json: any): Classification {
    return ClassificationFromJSONTyped(json, false);
}

export function ClassificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Classification {
    return json as Classification;
}

export function ClassificationToJSON(value?: Classification | null): any {
    return value as any;
}

